import {
  ApplicationRef,
  EnvironmentInjector,
  Injectable,
  Type,
  WritableSignal,
  createComponent,
  inject,
  signal,
} from '@angular/core';
import { HpDialogComponent } from './hp-dialog.component';
import { HpDialogConfig, HpDialogRef } from './hp-dialog.types';

@Injectable({ providedIn: 'root' })
export class HpDialogService {
  private _appRef = inject(ApplicationRef);
  private _injector = inject(EnvironmentInjector);

  open<C>(component: Type<C>, config: HpDialogConfig<C>): HpDialogRef {
    const hostEl = document.createElement('div');
    document.body.appendChild(hostEl);

    const componentRef = createComponent(HpDialogComponent, {
      environmentInjector: this._injector,
      elementInjector: config.injector,
      hostElement: hostEl,
    });

    const destroy = () => {
      this._appRef.detachView(componentRef.hostView);
      componentRef.destroy();
      hostEl.remove();
    };

    const dialogRef = new HpDialogRef(destroy);

    const inst = componentRef.instance;
    inst.title = config.title ?? '';
    inst.width = config.width ?? '520px';
    inst.height = config.height ?? null;
    inst.closable = config.closable ?? true;
    inst.dialogRef = dialogRef;
    inst.contentComponent = component as Type<unknown>;
    inst.contentInputs = { dialogRef, ...(config.inputs ?? {}) };
    inst.buttons = config.buttons ?? [];
    inst.ngOnInit();

    this._appRef.attachView(componentRef.hostView);
    componentRef.changeDetectorRef.detectChanges();

    return dialogRef;
  }
}
